import quickFetch from 'quick-fetch';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2, convertJsonToFieldValueAvro } from 'rpc-client-utils';
import { listVersionsCountedRpc, updateBufferRpc, restoreVersionToBufferRpc, restoreCombinedVersionToBufferRpc, pushBufferLiveRpc, pushCombinedBufferLiveByThemePathRpc, hasBufferedChangesRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ThemeSettingsRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const DEFAULT_PAGINATION_LIMIT = 15;
export const API_BASE = 'content/themes/v1/settings';
export const hasBufferedChanges = id => {
  const HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME = `has-buffered-changes-fetch`;
  const earlyRequest = quickFetch.getRequestStateByName(HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME);
  let resultPromise;
  const fetchChirpData = () => rpcClient.call(hasBufferedChangesRpc, {
    request: {
      id
    }
  });
  if (earlyRequest) {
    resultPromise = new Promise(resolve => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME);
      });
      earlyRequest.onError(() => {
        resultPromise = fetchChirpData();
        quickFetch.removeEarlyRequest(HAS_BUFFERED_CHANGES_EARLY_REQUEST_NAME);
      });
    });
  } else {
    resultPromise = fetchChirpData();
  }
  return resultPromise;
};
export const saveBuffer = (id, data) => {
  const CHIRPformattedValues = convertJsonToFieldValueAvro(data.values);
  const CHIRPformattedBreakpointStyles = convertJsonToFieldValueAvro(data.breakpointStyles);
  return rpcClient.call(updateBufferRpc, {
    request: {
      id,
      values: CHIRPformattedValues.value,
      breakpointStyles: CHIRPformattedBreakpointStyles.value
    }
  });
};
export const publishBuffer = id => rpcClient.call(pushBufferLiveRpc, {
  request: {
    id
  }
});
export const publishCombinedBuffer = (themeSettingsId, themePath) => rpcClient.call(pushCombinedBufferLiveByThemePathRpc, {
  request: {
    themeSettingsId,
    themePath
  }
});
export const fetchRevisions = (id, data) => rpcClient.call(listVersionsCountedRpc, {
  request: {
    objectId: id,
    pageLength: DEFAULT_PAGINATION_LIMIT,
    offset: {
      offset: data.offset || 0
    }
  }
});
export const revertCombinedThemeSettings = (id, data) => {
  const {
    themePath,
    versionId
  } = data;
  return rpcClient.call(restoreCombinedVersionToBufferRpc, {
    request: {
      modelId: id,
      themePath,
      versionId
    }
  });
};
export const revertThemeSettings = (id, data) => rpcClient.call(restoreVersionToBufferRpc, {
  request: {
    modelId: id,
    versionId: data.versionId
  }
});
export const fetchThemeVariant = (pathToTheme, variantName) => http.post(`${API_BASE}/variant/${variantName}/by-path/${pathToTheme}`);